import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, Phone, Zap } from 'lucide-react';
export function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navLinks = [{
    name: 'Classes',
    href: '/programs'
  }, {
    name: 'Summer Camp',
    href: '/summer-camp',
    highlight: true
  }, {
    name: 'Reviews',
    href: '/reviews'
  }, {
    name: 'Coaches',
    href: '/coaches'
  }, {
    name: 'Schedule',
    href: '/schedule'
  }, {
    name: 'Contact',
    href: '/contact'
  }];
  return <header className="sticky top-0 z-50 bg-paper border-b border-subtle-gray shadow-sm" data-id="element-157">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-158">
        <div className="flex justify-between items-center h-20" data-id="element-159">
          {/* Logo */}
          <Link to="/" className="flex items-center group" data-id="element-160">
            <img src="https://cdn.magicpatterns.com/uploads/6QQqEPrZA2yuM42sncUeU3/StormLogo.png" alt="Storm Taekwondo" className="h-14 md:h-16 w-auto object-contain transition-transform group-hover:scale-105" data-id="element-161" />
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-7" data-id="element-162">
            {navLinks.map(link => <Link key={link.name} to={link.href} className={link.highlight ? 'text-sm font-bold text-storm-red hover:text-storm-red-dark transition-colors uppercase tracking-wide flex items-center gap-1.5' : 'text-sm font-bold text-ink hover:text-storm-red transition-colors uppercase tracking-wide'} data-id="element-163">
                {link.highlight && <span className="w-1.5 h-1.5 rounded-full bg-storm-red animate-pulse" data-id="element-164" />}
                {link.name}
              </Link>)}
          </nav>

          {/* Desktop Actions */}
          <div className="hidden lg:flex items-center gap-6" data-id="element-165">
            <a href="tel:517-220-0621" className="flex items-center gap-2 text-ink hover:text-storm-red font-bold transition-colors" data-id="element-166">
              <Phone className="w-5 h-5" data-id="element-167" />
              <span data-id="element-168">517-220-0621</span>
            </a>
            <Link to="/free-trial" className="btn-primary py-3 px-6 text-lg" data-id="element-169">
              Claim Free Week
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button className="lg:hidden p-2 text-ink" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-170">
            {isMobileMenuOpen ? <X className="w-8 h-8" data-id="element-171" /> : <Menu className="w-8 h-8" data-id="element-172" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && <div className="lg:hidden absolute top-20 left-0 w-full bg-paper border-b border-subtle-gray shadow-xl py-4 px-4 flex flex-col gap-4" data-id="element-173">
          {navLinks.map(link => <Link key={link.name} to={link.href} className={link.highlight ? 'text-lg font-bold text-storm-red py-2 border-b border-subtle-gray flex items-center gap-2' : 'text-lg font-bold text-ink py-2 border-b border-subtle-gray'} onClick={() => setIsMobileMenuOpen(false)} data-id="element-174">
              {link.highlight && <span className="w-2 h-2 rounded-full bg-storm-red animate-pulse" data-id="element-175" />}
              {link.name}
            </Link>)}
          <div className="pt-4 flex flex-col gap-4" data-id="element-176">
            <a href="tel:517-220-0621" className="flex items-center justify-center gap-2 text-ink font-bold py-3 bg-subtle-gray rounded-xl" data-id="element-177">
              <Phone className="w-5 h-5" data-id="element-178" />
              <span data-id="element-179">Call 517-220-0621</span>
            </a>
            <Link to="/free-trial" className="btn-primary w-full" onClick={() => setIsMobileMenuOpen(false)} data-id="element-180">
              Claim Free Week
            </Link>
          </div>
        </div>}
    </header>;
}